import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-report" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "text-3" }
const _hoisted_7 = { class: "text-3" }

import { useI18n } from "vue-i18n";
import type { ReportType } from "@/common/types/report";

import { svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'card-report',
  props: {
    data: {},
    editable: { type: Boolean, default: true }
  },
  emits: ["edit", "copy", "delete"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.data.name), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.data.description), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn btn-sm btn-white",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('edit')))
      }, [
        _createVNode(_unref(svgIcon), {
          icon: "edit",
          size: "1.25rem"
        }),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("common.labels.edit")), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-sm btn-delete",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('delete')))
      }, [
        _createVNode(_unref(svgIcon), {
          icon: "trash",
          size: "1.25rem"
        }),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("common.labels.delete")), 1)
      ])
    ])
  ]))
}
}

})